import {
  Column,
  Entity,
  Index,
  JoinColumn,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn,
} from "typeorm";
import { AreaTreeNodes } from "./area-tree-nodes.entity";
import { Clients } from "./clients.entity";
import { Branches } from "./branches.entity";

@Index("index_services_on_client_id", ["clientId"], {})
@Index("services_pkey", ["id"], { unique: true })
@Entity("services", { schema: "public", synchronize: false, })
export class Services {
  @PrimaryGeneratedColumn({ type: "integer", name: "id" })
  id: number;

  @Column("integer", { name: "client_id", unique: true })
  clientId: number;

  @Column("character varying", { name: "name" })
  name: string;

  @Column("timestamp without time zone", { name: "created_at" })
  createdAt: Date;

  @Column("timestamp without time zone", { name: "updated_at" })
  updatedAt: Date;

  @Column("boolean", {
    name: "local_storage_accessible",
    default: () => "true",
  })
  localStorageAccessible: boolean;

  @Column("text", { name: "deny_device_message_ja", default: () => "''" })
  denyDeviceMessageJa: string;

  @Column("text", { name: "deny_device_message_en", default: () => "''" })
  denyDeviceMessageEn: string;

  @Column("text", { name: "deny_device_alert_to", default: () => "''" })
  denyDeviceAlertTo: string;

  @Column("boolean", { name: "enable_service", default: () => "true" })
  enableService: boolean;

  @Column("boolean", { name: "enable_agent", default: () => "false" })
  enableAgent: boolean;

  @Column("boolean", { name: "enable_skip_auth", default: () => "true" })
  enableSkipAuth: boolean;

  @Column("boolean", {
    name: "enable_todo_progress_csv_download",
    default: () => "false",
  })
  enableTodoProgressCsvDownload: boolean;

  @Column("character varying", { name: "created_by", nullable: true })
  createdBy: string | null;

  @Column("character varying", { name: "updated_by", nullable: true })
  updatedBy: string | null;

  @Column("boolean", { name: "enable_data_report", default: () => "false" })
  enableDataReport: boolean;

  @Column("boolean", { name: "enable_personal", default: () => "false" })
  enablePersonal: boolean;

  @Column("boolean", { name: "enable_manual", default: () => "true" })
  enableManual: boolean;

  @Column("boolean", { name: "enable_progress_update", default: () => "false" })
  enableProgressUpdate: boolean;

  @Column("boolean", { name: "enable_branch_external_link", default: () => "false" })
  enableBranchExternalLink: boolean;

  @OneToMany(() => AreaTreeNodes, (areaTreeNodes) => areaTreeNodes.service)
  areaTreeNodes: AreaTreeNodes[];

  @ManyToOne(() => Clients, (clients) => clients.services)
  @JoinColumn([{ name: "client_id", referencedColumnName: "id" }])
  client: Clients;

  @OneToMany(() => Branches, (branch) => branch.service)
  branches: Branches[]
}
